import { format } from "date-fns";
import { appLogger } from "@/services/AppLogger";

export const waitSeconds = (seconds: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, seconds * 1000);
  });
};

type QueryStringPrimitive = string | number | boolean;

export const getQueryStringParams = (options: object, keyPrefix: string = ""): string => {
  const dateFormat = "yyyy-MM-dd";
  const values = options as Record<string, unknown>;

  return Object.keys(values)
    .reduce((result: string[], key: string) => {
      const value = values[key];
      if (value !== undefined && value !== null && value !== "") result.push(key);
      return result;
    }, [])
    .map((key) => {
      let prefixedKey = keyPrefix.length > 0 ? `${keyPrefix}.${key}` : key;
      const value = values[key];

      if (Array.isArray(value)) {
        return value
          .map((item: unknown, index: number) => {
            prefixedKey = `${prefixedKey.replace(/\[\w+\]$/g, "")}[${index}]`;
            return typeof item === "object"
              ? getQueryStringParams(item as object, prefixedKey)
              : `${prefixedKey}=${encodeURIComponent(item as QueryStringPrimitive)}`;
          })
          .join("&");
      }

      if (Object.prototype.toString.call(value) === "[object Date]" && !isNaN(Number(value))) {
        return `${prefixedKey}=${format(value as Date, dateFormat)}`;
      }

      if (typeof value === "object") {
        return getQueryStringParams(value as object, prefixedKey);
      }

      return `${prefixedKey}=${encodeURIComponent(value as QueryStringPrimitive)}`;
    })
    .join("&");
};

export const copyTextToClipboardAsync = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    // Only the error: the copied text may be customer content.
    appLogger.logError(error instanceof Error ? error : new Error(String(error)));
  }
};
